.container {
  padding: 24px;

  /* Fix for "min-height: 100%"
  https://stackoverflow.com/questions/8468066/child-inside-parent-with-min-height-100-not-inheriting-height
  */
  flex: 1;
  display: flex;
  flex-direction: column;
}

.card {
  padding: 48px;
  /* Fix for min-height */
  flex: 1;
}
